module.exports = __webpack_public_path__ + "static/img/Poison.e0abda9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Poison.png
// module id = +3Lv
// module chunks = 21